module.exports = __webpack_public_path__ + "img/close-icon.eba2f30b.svg";